/**
 * NOTA DE REFACTOR: Este container conecta a lógica do hook useExportProgress à UI pura.
 * Remove mutações diretas de DOM e estado global, mantendo o comportamento original.
 */
import ExportProgressView from './ui/ExportProgressView';
import { useExportProgress } from './hooks/useExportProgress';

export interface ExportLayoutProgressModalProps {
  onComplete: () => void;
}

export function ExportLayoutProgressModal({ onComplete }: ExportLayoutProgressModalProps) {
  const {
    exportState,
    progress,
    currentObjectName,
    currentMessage,
    currentEtapa,
    fileStats,
    progressState,
    close,
  } = useExportProgress({ onComplete });

  return (
    <ExportProgressView
      exportState={exportState}
      progress={progress}
      currentObjectName={currentObjectName}
      currentMessage={currentMessage}
      currentEtapa={currentEtapa}
      fileStats={fileStats}
      progressInfo={{ total: progressState.totalObjetos, processed: progressState.objetosProcessados, currentIndex: progressState.objetoAtual - 1 }}
      onClose={close}
    />
  );
}

export default ExportLayoutProgressModal;


